/**
 * Converts hardcoded domain links to relative URLs with proper locale support.
 * Works for ohmygodnails.com and limea.com domains.
 * 
 * @param {string} containerSelector - CSS selector for the container to search for links
 * @param {string} localeRoot - Current locale root path from Shopify (e.g., "/" or "/nl/")
 */
function convertLinksToRelative(containerSelector, localeRoot) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  // Match ohmygodnails.com or limea.com URLs (with or without www, http or https)
  const domainPattern = /^https?:\/\/(www\.)?(ohmygodnails|limea)\.com/i;
  
  // Known locale prefixes to detect if path already has a locale
  const localePattern = /^\/(nl|de|fr|en|es|it|pt|da|sv|nb|fi|pl|cs|hu|ro|sk|sl|hr|lt|bg|el|ru|tr|th|vi|id|ja|ko|zh-CN|zh-TW|pt-BR|pt-PT)\//i;
  
  const links = container.querySelectorAll('a[href]');

  links.forEach(function(link) {
    const href = link.getAttribute('href');
    if (href && domainPattern.test(href)) {
      // Extract the path portion after the domain
      let path = href.replace(domainPattern, '');
      
      // If path is empty, set to root
      if (!path) {
        path = '/';
      }
      
      // If path doesn't already have a locale prefix, add the current locale
      if (!localePattern.test(path) && localeRoot !== '/') {
        // Ensure localeRoot ends with slash and path starts correctly
        const cleanLocale = localeRoot.endsWith('/') ? localeRoot : localeRoot + '/';
        const cleanPath = path.startsWith('/') ? path.slice(1) : path;
        path = cleanLocale + cleanPath;
      }
      
      link.setAttribute('href', path);
    }
  });
}
